import errorHandlerSaga from './errorHandler';

export const errorSagas = [errorHandlerSaga];
